import React from "react";
import useStyles from "./Styles";
import { MenuItem, TextField } from "@material-ui/core";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const CustomizedSelect = (props) => {
  const classes = useStyles();
  const { label, options, handleSelectedItem, dropdownValue, disabled } = props;
  const { isMobile } = useGetViewPortDimensions();
  
  return (
    <>
      <TextField
        select
        disabled={disabled}
        label={label}
        value={dropdownValue}
        variant='outlined'
        onChange={handleSelectedItem}
        className={isMobile ? classes.filterSelectResponsive : classes.filterSelect}
        InputProps={{
          classes: { input: classes.filter }
        }}
        SelectProps={{
          MenuProps:{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            style: {maxHeight: 400},
            getContentAnchorEl: null
          }
        }}
      >
        {
          options.map((option, idx) => (
            <MenuItem key={idx} value={option.value} classes={{ root: classes.menuItemRoot }}>{option.label}</MenuItem>
          ))
        }
      </TextField>  
    </>
    
  );
};

CustomizedSelect.defaultProps = {
  disabled: false
};

export default CustomizedSelect;
